import React, { useCallback, memo } from "react"
import Dialog from "@material-ui/core/Dialog"
import MuiDialogTitle from "@material-ui/core/DialogTitle"
import MuiDialogContent from "@material-ui/core/DialogContent"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import { withStyles, makeStyles } from "@material-ui/core/styles"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(5),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: "#ffffff",
        backgroundColor: theme.palette.primary.main,
        width: "28px",
        height: "28px",
        "&:hover": {
            backgroundColor: theme.palette.primary.secondary,
        },
    },
})

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    )
})

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(0),
    },
}))(MuiDialogContent)

const useStyles = makeStyles((theme) => ({
    dialogContent: {
        zIndex: "1",
    },
    contentWrapper: {
        padding: theme.spacing(0, 3),
        paddingBottom: theme.spacing(3),
        margin: "0 auto",
        maxWidth: "650px",
        textAlign: "center",
        "&>p": {
            marginBottom: theme.spacing(2),
        },
    },
    contentTitle: {
        marginBottom: theme.spacing(4),
    },
}))

const ModalNAChoice = memo((props) => {
    const { modalShow, handleClose, handleChoiceChange, finalResponseAssessmentContent, modalQuestionDetail } = props
    const classes = useStyles()
    const handleConfirm = useCallback(() => {
        const { event, questionId } = modalQuestionDetail
        handleChoiceChange(event, finalResponseAssessmentContent, questionId)
        handleClose()
    }, [modalQuestionDetail, finalResponseAssessmentContent])
    return (
        <Dialog disableScrollLock aria-labelledby="choose-na-" open={modalShow} maxWidth="md" fullWidth>
            <DialogTitle className={classes.closeButton} id="complete-project" onClose={handleClose} />
            <DialogContent className={classes.dialogContent}>
                <Box className={classes.contentWrapper}>
                    <Typography variant="h6" component="h2" className={classes.contentTitle} color="textPrimary">
                        Are you sure?
                    </Typography>
                    <Typography component="p">Please take another look at the response choices.</Typography>
                    <Box className={classes.buttonWrapper} m={4} display="flex" justifyContent="center" alignItems="center">
                        <Button variant="outlined" color="primary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Box>&nbsp;&nbsp;</Box>
                        <Button variant="contained" color="primary" onClick={handleConfirm}>
                            Confirm
                        </Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    )
})

export default ModalNAChoice
